import { render, staticRenderFns } from "./valuation.vue?vue&type=template&id=7a874d6b&"
import script from "./valuation.vue?vue&type=script&lang=js&"
export * from "./valuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports